import { useState, useCallback, useEffect, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import { fetchCategoryRankingsData } from '@reducers/ranking/rankingThunk';
import { setSelectCategory, setTabValue } from '@reducers/ranking/rankingSlice';
import DatePickerRangeButton from '@components/atom/layout/datePicker/rangeButton';
import { CommonUtil } from '@utils/common/common';
import moment from 'moment';
import { uniqBy } from 'lodash';

//TODO: 여기서 datePicker로 변경시 fetch로 데이터 요청하기!
const SelectBox = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { categoryRankings, categoriesSelected, categoryTabValue } = useSelector(({ ranking }: RootState) => ranking);

  // select state
  const [properties, setProperties] = useState(null);
  // datepicker states
  const [startDate, setStartDate] = useState(CommonUtil.addDate(moment().format('YYYY.MM.DD'), -15));
  const [endDate, setEndDate] = useState(CommonUtil.addDate(moment().format('YYYY.MM.DD'), -1));

  // useEffect for reqData
  useEffect(() => {
    if (startDate && endDate) {
      dispatch(
        fetchCategoryRankingsData({
          email: 'SS',
          startDate: startDate.toString(),
          endDate: endDate.toString(),
        })
      );
    }
  }, [endDate]);

  // useEffect for setProperties (selectData 뽑아내기)
  useEffect(() => {
    if (categoryRankings) {
      setProperties(uniqBy(categoryRankings[categoryTabValue], 'property').map((item) => item.property));
    }
  }, [categoryRankings]);

  // useCallback for onChange Select tag
  const onChangeSelect = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      const { value } = event.currentTarget;
      if (value !== 'All') {
        dispatch(setSelectCategory({ categoryList: [value] }));
      } else {
        dispatch(setSelectCategory({ categoryList: [] }));
      }
    },
    [dispatch, setSelectCategory]
  );

  return (
    <div className="top-charts-wrap">
      <div className="top-charts-box">
        <label className="select">
          <select
            onChange={onChangeSelect}
            value={categoriesSelected === null || categoriesSelected.length > 1 ? 'All' : categoriesSelected[0]}
          >
            <option value={'All'}>All </option>
            {properties &&
              properties.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
          </select>
        </label>
      </div>
      {/* <div className="period_select_bx"> */}
      <div className="period_select_bx">
        <div className="period_select_in">
          <DatePickerRangeButton
            layoutStartDate={startDate}
            layoutEndDate={endDate}
            setLayoutStartDate={setStartDate}
            setLayoutEndDate={setEndDate}
            isClearable={false}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectBox;
